import React from 'react';
import { AccountDetailMetric } from '@/experiences/sales-portal/domain/accounts/screens/account-detail/blocs/loaders/use-account-detail-metrics-loader';
import { createStyles } from '@/contexts/theme-context';
import { MetricDelta } from '@/experiences/sales-portal/domain/accounts/screens/account-detail/components/metric-delta';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface AccountDetailMetricsListProps {
  metrics: AccountDetailMetric[] | null;
}

export const AccountDetailMetricsList: React.FC<
  AccountDetailMetricsListProps
> = ({ metrics }) => {
  const [styles, theme] = useStyles();

  if (!metrics) {
    return null;
  }

  return (
    <View role="list" style={styles.card}>
      {metrics.map((metric, index) => (
        <View
          key={metric.label}
          role="listitem"
          style={[styles.row, index === 0 ? styles.rowFirst : null]}
        >
          <Typography
            color={theme.sk.color.text.secondary}
            variant="paragraph-base"
          >
            {metric.label}
          </Typography>
          <View style={styles.valueColumn}>
            <Typography variant="paragraph-md-600">{metric.value}</Typography>
            <MetricDelta
              changePercentage={metric.changePercentage}
              size="$md"
            />
          </View>
        </View>
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  card: {
    borderColor: theme.sk.color.border.primary,
    borderRadius: theme.sk.radii.radiusMedium,
    borderWidth: 1,
    overflow: 'hidden',
  },
  row: {
    alignItems: 'flex-start',
    borderTopColor: theme.sk.color.border.primary,
    borderTopWidth: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: theme.sk.spacing.spaceMedium,
    paddingVertical: theme.sk.spacing.spaceMedium,
  },
  rowFirst: {
    borderTopWidth: 0,
  },
  valueColumn: {
    alignItems: 'flex-end',
    gap: theme.sk.spacing.spaceXsmall,
  },
}));
